(() => {

    let active = false;

    let dispatchActivity = () => {
        if (active) {
            return;
        }
        active = true;
        document.dispatchEvent(new CustomEvent('UserInteracted'));
    };

    const interact = () => {
        let activities = [
            'mousedown', 
            'mousemove', 
            'keydown', 
            'scroll', 
            'touchstart', 
            'click', 
            'keypress', 
            'touchmove'
        ];
        activities.forEach((activity) => {
            window.addEventListener(activity, dispatchActivity, false);
        });
    };

    document.addEventListener('DOMContentLoaded', interact, false);

})();